import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { mapSidebarSettingTabs, sidebarObjectTabs } from 'constants/map';
import { mapRoutes, monitoringRoutes } from 'constants/routes';
import { useMapRef } from 'hooks/map';
import { ReactComponent as TimelineIcon } from 'images/newIcons/clock.svg';

import { MapTimeline } from '../Tabs/Timeline';

import { ASIDE_WIDTH, TITLE_TOOLTIP } from './constants';
import { SidebarBody } from './SidebarBody';
import { SidebarButton } from './SidebarButton';
import { SidebarTab } from './SidebarTab';

export const MapSidebar = () => {
  const { pathname } = useLocation();
  const { mapRef } = useMapRef();
  const [showBody, setShowBody] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);

  const mapCanvas = mapRef.current?.getCanvas();

  useEffect(() => {
    const isActiveTab = Object.values({
      ...mapRoutes,
      ...monitoringRoutes,
    }).includes(pathname);

    setShowBody(isActiveTab);
  }, [pathname]);

  useEffect(() => {
    if (mapCanvas) {
      mapCanvas.setAttribute(
        'style',
        `width: 100%; height: -webkit-fill-available;`
      );

      setTimeout(() => mapRef.current?.resize(), 300);
    }
  }, [mapCanvas, showBody]);

  return (
    <aside className="relative flex h-full" style={{ minWidth: ASIDE_WIDTH }}>
      <nav className="flex flex-col gap-6 justify-between items-center w-full h-full py-6 bg-light">
        <ul className="flex flex-col gap-6 flex-1">
          {sidebarObjectTabs.map((tab, index) => (
            <SidebarTab
              {...tab}
              key={index}
              link={tab.link}
              title={TITLE_TOOLTIP[tab.title]}
              isActive={tab.link === pathname}
            />
          ))}
        </ul>
        <ul className="flex flex-1 flex-col gap-6 justify-center">
          {mapSidebarSettingTabs.map((tab, index) => (
            <SidebarTab
              {...tab}
              key={index}
              link={tab.link}
              title={TITLE_TOOLTIP[tab.title]}
              isActive={tab.link === pathname}
            />
          ))}
        </ul>
        <ul className="flex flex-1 flex-col w-full justify-end items-center">
          <SidebarButton
            title="ТАЙМЛАЙН"
            isActive={showTimeline}
            onClick={() => setShowTimeline(!showTimeline)}
            passiveIcon={<TimelineIcon />}
            activeIcon={<TimelineIcon className="text-bright_product" />}
          />
        </ul>
      </nav>
      {showBody && <SidebarBody />}
      {showTimeline && <MapTimeline isSidebarOpen={showBody} />}
    </aside>
  );
};
